import { Dropdown, Menu } from "antd";
import { StyledTopBar } from "./styles";
import Button from "../../../components/generic/Button";
import { Link } from "react-router-dom";
import { ROUTES } from "../../../constant/routes";
import { DownOutlined } from "@ant-design/icons";
import Logo from "../../../assets/images/logo.png";
import { CUSTOMER_LOGIN } from "../../../utils/AiService/constant";

const TopBar = () => {
  return (
    <StyledTopBar>
      <div className="flex align-center justify-space-between top-div">
        <div className="flex align-center left-section">
          <div className="logo flex-centre rounded bg-primary">
            <img src={Logo} />
          </div>
          <span className="brand-text">Kelu</span>
        </div>

        <div className="flex  right-section">
          <Menu className="justify-end nav-menu " mode="horizontal">
            {["Features", "How It Works", "Pricing", "About"].map(
              (item, index) => (
                <Menu.Item key={index}>
                  <Link to={`/#${item.toLowerCase().replaceAll(" ", "_")}`}>
                    {item}
                  </Link>
                </Menu.Item>
              ),
            )}
            <Menu.Item>
              <Link to={`/blogs`}>Blogs</Link>
            </Menu.Item>
            <Menu.Item key="sign-in-dropdown">
              <Dropdown
                menu={{
                  items: [
                    {
                      key: "business",
                      label: <Link to={ROUTES.SIGNIN}>Business Portal</Link>,
                    },
                    {
                      key: "customer",
                      label: (
                        <a
                          href={CUSTOMER_LOGIN}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Customer Login
                        </a>
                      ),
                    },
                  ],
                }}
                placement="bottomRight"
              >
                <div>
                  Sign In &nbsp; <DownOutlined />
                </div>
              </Dropdown>
            </Menu.Item>
            <Menu.Item key="start-trial">
              <Button className="start-trial-btn">
                <Link to={ROUTES.SIGNUP}>Start Free Trial</Link>
              </Button>
            </Menu.Item>
          </Menu>
        </div>
      </div>
    </StyledTopBar>
  );
};

export default TopBar;
